import { useEffect, useState } from "react";
import { getNflCurrentSeason } from "../api/nflSurvivor";

// Module-level cache so the season is fetched once per page load, matching usePlSeason.
let _cached = null;
let _promise = null;

export function useNflSeason() {
  const [season, setSeason] = useState(_cached);
  const [loading, setLoading] = useState(!_cached);

  useEffect(() => {
    if (_cached) {
      setSeason(_cached);
      setLoading(false);
      return;
    }
    if (!_promise) {
      _promise = getNflCurrentSeason();
    }
    _promise
      .then((data) => {
        _cached = data;
        setSeason(data);
      })
      .catch(() => {
        _promise = null;
        setSeason(null);
      })
      .finally(() => setLoading(false));
  }, []);

  return { season, seasonId: season?.id ?? null, loading };
}
